import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/pages/home/home.component';
import { LoginPageComponent } from './components/pages/login-page/login-page.component';
import { UserPageComponent } from './components/pages/user-page/user-page.component';
import { ListUserPageComponent } from './components/pages/list-user-page/list-user-page.component';
import { ListTankPageComponent } from './components/pages/list-tank-page/list-tank-page.component';
import { TankPageComponent } from './components/pages/tank-page/tank-page.component';
import { FuelPageComponent } from './components/pages/fuel-page/fuel-page.component';
import { ListFuelPageComponent } from './components/pages/list-fuel-page/list-fuel-page.component';
import { VehiclePageComponent } from './components/pages/vehicle-page/vehicle-page.component';
import { ListVehiclePageComponent } from './components/pages/list-vehicle-page/list-vehicle-page.component';
import { ChargePageComponent } from './components/pages/charge-page/charge-page.component';
import { ListChargesPageComponent } from './components/pages/list-charges-page/list-charges-page.component';
import { VoucherPageComponent } from './components/pages/voucher-page/voucher-page.component';
import { ListVoucherPageComponent } from './components/pages/list-voucher-page/list-voucher-page.component';
import { DischargePageComponent } from './components/pages/discharge-page/discharge-page.component';
import { ListDischargePageComponent } from './components/pages/list-discharge-page/list-discharge-page.component';
import { AuthGuard } from './auth.guard';
import { WebAccessDisabledPageComponent } from './components/pages/web-access-disabled-page/web-access-disabled-page.component';
import { PumpPageComponent } from './components/pages/pump-page/pump-page.component';
import { PrintVoucherPageComponent } from './components/pages/print-voucher-page/print-voucher-page.component';
// Importa otros componentes que desees vincular a rutas

const routes: Routes = [


  { path: '', component: LoginPageComponent },
  { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
  { path: 'login', component: LoginPageComponent },
  { path: 'web-access-disabled', component: WebAccessDisabledPageComponent, canActivate: [AuthGuard], data: { skipWebAccessCheck: true } },

  { path: 'new-user', component: UserPageComponent },
  { path: 'edit-users/:id', component: UserPageComponent, canActivate: [AuthGuard] },
  { path: 'users', component: ListUserPageComponent, canActivate: [AuthGuard] },

  { path: 'new-tank', component: TankPageComponent, canActivate: [AuthGuard] },
  { path: 'edit-tank/:id', component: TankPageComponent, canActivate: [AuthGuard] },
  { path: 'tanks', component: ListTankPageComponent, canActivate: [AuthGuard] },

  { path: 'new-fuel', component: FuelPageComponent, canActivate: [AuthGuard] },
  { path: 'edit-fuel/:id', component: FuelPageComponent, canActivate: [AuthGuard] },
  { path: 'fuels', component: ListFuelPageComponent, canActivate: [AuthGuard] },

  { path: 'new-vehicle', component: VehiclePageComponent, canActivate: [AuthGuard] },
  { path: 'edit-vehicle/:id', component: VehiclePageComponent, canActivate: [AuthGuard] },
  { path: 'vehicles', component: ListVehiclePageComponent, canActivate: [AuthGuard] },

  { path: 'new-charge', component: ChargePageComponent, canActivate: [AuthGuard] },
  { path: 'edit-charge/:id', component: ChargePageComponent, canActivate: [AuthGuard] },
  { path: 'charges', component: ListChargesPageComponent, canActivate: [AuthGuard] },


  { path: 'new-voucher', component: VoucherPageComponent, canActivate: [AuthGuard] },
  { path: 'edit-voucher/:id', component: VoucherPageComponent, canActivate: [AuthGuard] },
  { path: 'vouchers', component: ListVoucherPageComponent, canActivate: [AuthGuard] },

  { path: 'new-discharge', component: DischargePageComponent, canActivate: [AuthGuard] },
  { path: 'discharges', component: ListDischargePageComponent, canActivate: [AuthGuard] },

  { path: 'pumps', component: PumpPageComponent, canActivate: [AuthGuard] },

  { path: 'print-voucher/:id', component: PrintVoucherPageComponent, canActivate: [AuthGuard] },


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
